module.exports = __webpack_public_path__ + "media/images/svg/realestate/mansion-08b69e92bdea2e06b2fce12c8976cef4.svg";